<template lang="pug">
Auth(@loginFailed="onFailedAuthentication")
  Header(:content="headerContent")
  div.wrap-tmp.f.fh
    //- ModuleTmp
    span tmp
</template>

<style lang="scss" scoped>
.wrap-tmp {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import { createNamespacedHelpers } from "vuex"
import Auth from "@/components/auth"
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers("auth")
import Header from "@/components/shared/Header"
import ModuleTmp from "@/components/module/ModuleTmp"

export default {
  components: {
    Auth,
    Header,
    ModuleTmp
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return  {
      headerContent: {
        label: 'Tmp',
        rightAction: {
          icon: 'add',
          color: '#1967d2',
          method: this.onHeaderRight
        }
      }
    }
  },
  created () {
    
  },
  methods: {
    onFailedAuthentication () {
      this.$router.push("/sign-in")
    },
    onHeaderRight () {
      console.log("on right")
    }
  }
}
</script>
